var SOCIALSHARING = (function() {
  function init() {
    var url = window.location.href;
    var metaDescription =
      document.querySelector('meta[name="description"]') &&
      document.querySelector('meta[name="description"]').content;
    var facebook = document.querySelectorAll(".c-sharing__button--facebook");
    var twitter = document.querySelectorAll(".c-sharing__button--twitter");
    var linkedin = document.querySelectorAll(".c-sharing__button--linkedin");

    facebook.forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault();
        window
          .open("https://www.facebook.com/sharer/sharer.php?u=" + url, "_blank")
          .focus();
      });
    });

    twitter.forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault();
        window
          .open(
            "https://twitter.com/intent/tweet?text=" +
              metaDescription +
              "&url=" +
              url,
            "_blank"
          )
          .focus();
      });
    });

    linkedin.forEach(function(link) {
      link.addEventListener("click", function(e) {
        e.preventDefault();
        window
          .open(
            "https://www.linkedin.com/shareArticle?mini=true&url=" + url,
            "_blank"
          )
          .focus();
      });
    });
  }

  return {
    init: init,
  };
})();
